// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__heb_a","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1OUdC"};